// extracted by mini-css-extract-plugin
export default {"container":"InstrumentStatus_container__axFNE","icon":"InstrumentStatus_icon__0rA-N"};